import { React, useState } from "react";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";

const camposIniciales = { nombre: "", descripcion: "" };

const AgregarPresentacionModal = ({ open, onClose }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [form, setForm] = useState(camposIniciales);

    const onChange = ({ target }) => {
        setForm((prev) => ({ ...prev, [target.name]: target.value }));
    };

    const validar = () => {
        if (!form.nombre.trim()) {
            Swal.fire({
                title: "PRESENTACIONES",
                text: "El nombre es requerido",
                icon: "warning",
                customClass: { container: "mi-superpoop" },
            });
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (!validar()) return;
        setLoader({ ...loader, mostrar: true });

        const post = {
            presentacionId: crypto.randomUUID(),
            nombre: form.nombre.trim(),
            descripcion: form.descripcion.trim(),
            usuario: 0,
        };

        request
            .post("Presentacion/Guardar", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "PRESENTACIONES",
                    text: "Presentación guardada con éxito",
                    icon: "success",
                    customClass: { container: "mi-superpoop" },
                });
                handleCancelar();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PRESENTACIONES", JSON.stringify(error), "error");
            });
    };

    const handleCancelar = () => {
        setForm(camposIniciales);
        onClose();
    };

    return (
        <Modal open={open} onClose={handleCancelar}>
            <div className="agregar-presentacion-modal-formulario">
                <div className="agregar-presentacion-modal-plantilla">
                    <div className="plantilla-screen-filtro-container" id="agregar-presentacion-modal">
                        <PlantillaScreen
                            titulo="NUEVA PRESENTACIÓN"
                            className_main={1}
                            className="plantilla-screen-filtro-container-modal"
                        >
                            <div className="cerrar-modal-button" onClick={handleCancelar}>X</div>
                            <LoaderScreen loader={loader} />
                            <div className="agregar-presentacion-modal-content">
                                <div className="agregar-presentacion-modal-content-container scroll-4">
                                    <div className="pres-form-group">
                                        <label>Nombre *</label>
                                        <input
                                            type="text"
                                            name="nombre"
                                            value={form.nombre}
                                            onChange={onChange}
                                            placeholder="Nombre de la presentación"
                                            maxLength={200}
                                        />
                                    </div>
                                    <div className="pres-form-group">
                                        <label>Descripción</label>
                                        <textarea
                                            name="descripcion"
                                            value={form.descripcion}
                                            onChange={onChange}
                                            placeholder="Descripción de la presentación"
                                            rows={4}
                                        />
                                    </div>
                                </div>
                                <div className="agregar-presentacion-modal-buttons">
                                    <button
                                        className="agregar-presentacion-modal-button-cancelar"
                                        onClick={handleCancelar}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        className="agregar-presentacion-modal-button-guardar"
                                        onClick={handleGuardar}
                                        disabled={loader.mostrar}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AgregarPresentacionModal;
